import Utils from "../services/utils.js"

export default class Profile {
  constructor(data) { // response.data
    if (!data) {
      this.id = null;
      this.version = 0;
      this.firstName = null;
      this.lastName = null;
      this.companyName = null;
      this.email = null;
      this.locale = null;
      this.role = null;
      this.responsibleName = null;
      this.passwordOld = null;
      this.passwordNew = null;
      this.passwordNewConfirm = null;
    } else {
      this.id = data.id;
      this.version = data.version;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
      this.companyName = data.companyName;
      this.email = data.email;
      this.locale = data.locale;
      this.role = data.role;
      this.responsibleName = data.responsibleName;
      this.passwordOld = null;
      this.passwordNew = null;
      this.passwordNewConfirm = null;
    }
  }

  beforeSubmit() {
    if (Utils.isBlank(this.passwordOld)) {
      this.passwordOld = null;
    }
    if (Utils.isBlank(this.passwordNew)) {
      this.passwordNew = null;
    }
    if (Utils.isBlank(this.passwordNewConfirm)) {
      this.passwordNewConfirm = null;
    }
  }

  get displayName() {
    let displayName = this.firstName == null ? "" : this.firstName + " ";
    displayName += this.lastName == null ? "" : this.lastName;
    return displayName;
  }
}



// WEBPACK FOOTER //
// ./src/models/Profile.js